<template>
  <div>
    <i class="fas fa-bell fa-2x c-orange mr-2 mb-3"></i>
    <h4 class="text-uppercase c-orange font-weight-bold d-inline">
      Canais de notificações
    </h4>
    <div class="col-md-12 mb-5 mt-3">
      <div class="form-group">
        <div class="row">
          <div class="col-md-3">
            <div class="ml-2">
              <b-form-checkbox v-model="Fields.whatsapp" switch>
                WhatsApp
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-3">
            <div class="ml-2">
              <b-form-checkbox v-model="Fields.email" switch>
                E-mail
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-3">
            <div class="ml-2">
              <b-form-checkbox v-model="Fields.push_web" switch>
                Web Push Notifications
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-3">
            <div class="ml-2">
              <b-form-checkbox v-model="Fields.push_mobile" switch>
                Mobile Push Notifications
              </b-form-checkbox>
            </div>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-success text-white my-3"
          @click="submit()"
        >
          Salvar notificações
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import makeToast from '../mixins/makeToast';

export default {
  name: 'AcceptNotifications',
  mixins: [makeToast],
  data: () => ({
    Fields: {
      push_mobile: true,
      push_web: true,
      whatsapp: true,
      email: true,
      user_id: null,
    },
  }),

  computed: {
    ...mapState(['dadosUsuario']),
  },

  mounted() {
    this.getNotifications();
  },

  methods: {
    getNotifications() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('getNotifications', this.dadosUsuario.id)
        .then((data) => {
          if (data.data.type === 'success') {
            this.Fields.push_mobile = data.data.dados.mobile_push;
            this.Fields.push_web = data.data.dados.web_push;
            this.Fields.email = data.data.dados.email;
            this.Fields.whatsapp = data.data.dados.whatsapp;
          }
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao buscar dados!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },

    submit() {
      this.Fields.user_id = this.dadosUsuario.id;
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('updateNotifications', this.Fields)
        .then((data) => {
          if (data.data.type === 'error') {
            this.makeToast('Oopss', 'Erro ao buscar dados!', 'danger');
          }
          if (data.data.type === 'success') {
            this.getNotifications();
            this.makeToast(
              'sucesso',
              'Dados atualizados com sucesso!',
              'success'
            );
          }
        })
        .catch(() => this.makeToast('Oopss', 'Erro ao atualizar!', 'danger'))
        .finally(() => this.$store.dispatch('endLoader'));
    },
  },
};
</script>
<style></style>
